import dummy from "../assets/images/dummy.svg";
import offsetRandom from "../assets/images/widePlank/offsetRandom.jpg";
import eightInch from "../assets/images/widePlank/8in.jpg";

export const configuratorData1 = {
  tokenUrl: '9b7da761-b14b-3f41-8ef3-91b541db3e13',
  id: 1,
  name: 'New Oak Tree',
}

export const REGULAR_SIZE = "Regular"
export const WIDE_SIZE = "Wide"

export const profileData1 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData1 = [
  {
    id: 1,
    name: REGULAR_SIZE,
    thumb: eightInch,
  },
  {
    id: 2,
    name: WIDE_SIZE,
    thumb: eightInch,
  },
];

export const sceneData1 = [
  {
    id: 5936,
    name: "Scene",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 5935,
    name: "Scene",
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
];

export const imageHubSpotPosition1 = {
  // 'Rug': [
  //   {
  //     style: [
  //       { top: '75%', left: '46%' },
  //     ],
  //   },
  // ],
};

export const imageData1 = [
  {
    sceneId: 421,
    labelId: 1723,
    min: 0,
    max: 1,
  },
  {
    sceneId: 423,
    labelId: 1725,
    min: 1,
    max: 2,
  },
  {
    sceneId: 424,
    labelId: 1786,
    min: 0,
    max: 1,
  },
  {
    sceneId: 755,
    labelId: 1791,
    min: 1,
    max: 2,
  },
];

export const redirectURL1 = [
  {
    url: "https://www.welspunliving.com/",
    name: "Nebula Reverie",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Celestial Cascade",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Fiona Patchwork",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Lunar Lattice",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Stardust Tapestry",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Eclipse Enigma",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Aurora Gleam",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Harlequin Reverse",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Floral Symphony",
  },
];

export const dipTrayStyle1 = [
  // {
  //   configuratorId: 2,
  //   id: 1,
  //   name: "Standard",
  //   thumb: standard,
  // },
  // {
  //   configuratorId: 2,
  //   id: 2,
  //   name: "No Drip Trays",
  //   thumb: standard,
  // },
];
